import React from 'react';
import Button from '../../Shared/UI/Button/components/Button';

import {
  useEventState,
  useEventActions
} from './EventContext';

import {
  closeEventInvitation,
  generateAndSendEventInvitation,
  recordAttendance,
} from './restApi';

import styles from './EventAttendees.module.scss';

const EventAttendeesTable = () => {
  const state = useEventState();
  const { onResponse, onError } = useEventActions();

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const tableActionByEventAttendeeState = {
    'pending': {
      'text': 'Send Invitation',
      'action': (eventAttendee) => {
        generateAndSendEventInvitation({
          id: state?.event?.id,
          onResponse,
          onError,
          body: {
            authenticity_token: authenticityToken,
            event_attendee_id: eventAttendee.id,
          },
        });
      },
    },
    'invitation_sent': {
      'text': 'Close Invitation',
      'action': (eventAttendee) => {
        closeEventInvitation({
          id: state?.event?.id,
          onResponse,
          onError,
          body: {
            authenticity_token: authenticityToken,
            event_attendee_id: eventAttendee.id,
          },
        });
      },
    },
    'accepted_invitation': {
      'text': 'Record Attendance',
      'action': (eventAttendee) => {
        recordAttendance({
          id: state?.event?.id,
          onResponse,
          onError,
          body: {
            authenticity_token: authenticityToken,
            event_attendee_id: eventAttendee.id,
          },
        });
      },
    },
    'declined_invitation': {
      'text': 'Record Attendance',
      'action': (eventAttendee) => {
        recordAttendance({
          id: state?.event?.id,
          onResponse,
          onError,
          body: {
            authenticity_token: authenticityToken,
            event_attendee_id: eventAttendee.id,
          },
        });
      },
    },
    'invitation_closed': {
      'text': 'Send New Invitation',
      'action': (eventAttendee) => {
        generateAndSendEventInvitation({
          id: state?.event?.id,
          onResponse,
          onError,
          body: {
            authenticity_token: authenticityToken,
            event_attendee_id: eventAttendee.id,
          },
        });
      },
    },
    'attended_event': {
      'text': 'No Action',
      'action': () => {},
    },
  };

  return (
    <section className={styles.section}>
      <h2 className={styles.tableTitle}>
        Event Attendees
      </h2>
      {state?.event?.eventAttendees?.length ? (
        <table id={styles.table}>
          <thead>
            <tr className={styles.tr}>
              <th className={styles.th}>Name</th>
              <th className={styles.th}>Email</th>
              <th className={styles.th}>State</th>
              <th className={styles.th}>Invitation Expires At</th>
            </tr>
          </thead>
          <tbody>
            {state?.event?.eventAttendees?.map(eventAttendee => {
              return (
                <tr key={eventAttendee.id}  className={styles.tr}>
                  <td className={styles.td}>{eventAttendee.firstName} {eventAttendee.lastName}</td>
                  <td className={styles.td}>{eventAttendee.email}</td>
                  <td className={styles.td}>{eventAttendee.aasmState}</td>
                  <td className={styles.td}>{eventAttendee.openEventInvitation ? (eventAttendee.openEventInvitation.expiresAt) : ("N/A")}</td>
                  <td className={styles.td}>
                    <Button
                      variant="primary"
                      onClick={() => {
                        tableActionByEventAttendeeState[eventAttendee.aasmState]['action'](eventAttendee);
                      }}
                    >
                      {tableActionByEventAttendeeState[eventAttendee.aasmState]['text']}
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <p className={styles.noContentMessage}>No event attendees.</p>
      )}
    </section>
  );
};

export default EventAttendeesTable;
